import { render, staticRenderFns } from "./EditProductPanel.vue?vue&type=template&id=3bf90500"
import script from "./EditProductPanel.vue?vue&type=script&lang=js"
export * from "./EditProductPanel.vue?vue&type=script&lang=js"
import style0 from "./EditProductPanel.vue?vue&type=style&index=0&id=3bf90500&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports